import React from 'react'
import styled from 'styled-components'

const Document = styled.img`
    display: none;
    height: 70px;
    width: fit-content;
    background-color: #000;
    border-radius: 10px;
    &:hover{
        cursor: pointer;
        opacity: 0.8;
    }
`

const Description = styled.div`
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary + 99};
    margin-bottom: 10px;
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`

const Span = styled.span`
  overflow: visible;
  display: block;
  max-width: 100%;
  -webkit-line-clamp: unset;
  -webkit-box-orient: vertical;
  text-overflow: initial;
  white-space: pre-line;
`

const Card = styled.div`
    width: 650px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
    padding: 12px 16px;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: box-shadow 0.4s cubic-bezier(0.23, 1, 0.32, 1), transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    will-change: transform, box-shadow;
    @media only screen and (max-width: 768px){
        padding: 10px;
        gap: 8px;
        width: 300px;
    }
    &:hover {
        box-shadow: 0px 8px 32px rgba(132, 76, 230, 0.22), 0px 0px 20px rgba(0,0,0,0.2);
        transform: translateY(0) scaleY(1.04);
        animation: rollDownCard 0.7s cubic-bezier(0.23, 1, 0.32, 1);
    }
    @keyframes rollDownCard {
        0% { transform: translateY(-40px) scaleY(0.8); opacity: 0.7; }
        60% { transform: translateY(8px) scaleY(1.05); opacity: 1; }
        100% { transform: translateY(0) scaleY(1.04); opacity: 1; }
    }
    &:hover ${Document}{
        display: flex;
    }
    &:hover ${Span}{
        overflow: visible;
        -webkit-line-clamp: unset;
    }
    border: 0.1px solid #306EE8;
`

const Top = styled.div`
    width: 100%;
    display: flex;
    gap: 12px
`

const Image = styled.img`
    height: 50px;
    background-color: #ffff;
    border-radius: 10px;
    margin-top: 4px;
    @media only screen and (max-width: 768px){
        height: 40px;
    }
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column; 
`


const Role = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: ${({ theme }) => theme.text_primary};
    background: linear-gradient(135deg, ${({ theme }) => theme.text_primary}, ${({ theme }) => theme.primary});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 4px;
    @media only screen and (max-width: 768px){
        font-size: 16px;
    }
`

const Company = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.text_secondary + 99};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`

const Date = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary + 80};
    @media only screen and (max-width: 768px){
        font-size: 10px;
    }
`


const Skills = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    margin-top: -10px;
`

const ItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

const Skill = styled.div`
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary + 99};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`

const TimelineWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    left: 32px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, ${({ theme }) => theme.primary} 0%, ${({ theme }) => theme.card_light} 100%);
    border-radius: 2px;
    z-index: 0;
  }
`;

const MilestoneCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin-bottom: 32px;
  margin-left: 0;
  background: linear-gradient(120deg, ${({ theme }) => theme.card_light} 80%, ${({ theme }) => theme.primary + '22'} 100%);
  border-radius: 18px;
  box-shadow: 0 4px 24px ${({ theme }) => theme.primary + '11'};
  border: 1.5px solid ${({ theme }) => theme.primary + '33'};
  padding: 24px 32px 24px 56px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1;
  transition: box-shadow 0.3s, background 0.3s;
  min-height: 120px;
  word-break: break-word;
  white-space: pre-line;
  @media only screen and (max-width: 900px){
    max-width: 95vw;
    padding: 16px 8px 16px 32px;
    margin-bottom: 18px;
  }
`;

const Dot = styled.div`
  position: absolute;
  left: -32px;
  top: 32px;
  width: 18px;
  height: 18px;
  background: ${({ theme }) => theme.primary};
  border-radius: 50%;
  box-shadow: 0 0 12px ${({ theme }) => theme.primary + '66'};
  border: 2px solid ${({ theme }) => theme.card_light};
  z-index: 2;
`;

const ExperienceCard = ({ experience, active }) => {
    return (
        <MilestoneCard className={active ? 'active' : ''}>
            <Dot />
            <Top>
                <Image src={experience.img} />
                <Body>
                    <Role>{experience.role}</Role>
                    <Company>{experience.company}</Company>
                    <Date>{experience.date}</Date>
                </Body>
            </Top>
            <Description>
                {experience?.desc &&
                    <Span>{experience?.desc}</Span>
                }
                {experience?.skills &&
                    <>
                        <br />
                        <Skills>
                            <b>Skills:</b>
                            <ItemWrapper>
                                {experience?.skills?.map((skill, index) => (
                                    <Skill key={index}>• {skill}</Skill>
                                ))}
                            </ItemWrapper>
                        </Skills>
                    </>
                }
            </Description>
        </MilestoneCard>
    )
}

export default ExperienceCard